import { createFileRoute } from '@tanstack/react-router'

import { Page } from '@/components/page'
import { ActivityScreen } from '@/features/activity/ActivityScreen'

export const Route = createFileRoute('/activity')({ component: ActivityPage })

function ActivityPage() {
  return (
    <Page title="Activity" description="Everything that changed, newest first.">
      <ActivityScreen />
    </Page>
  )
}
